import HateBuddy from './images/buddies/hate.svg';
import HateAlternateBuddy from './images/buddies/hate_alt.svg';
import DislikeBuddy from './images/buddies/dislike.svg';
import DislikeAlternateBuddy from './images/buddies/dislike_alt.svg';
import NeutralBuddy from './images/buddies/neutral.svg';
import NeutralAlternateBuddy from './images/buddies/neutral_alt.svg';
import LikeBuddy from './images/buddies/like.svg';
import LikeAlternateBuddy from './images/buddies/like_alt.svg';
import LoveBuddy from './images/buddies/love.svg';
import LoveAlternateBuddy from './images/buddies/love_alt.svg';
import type { EmotionScore, FeedbackIconComponent, FeedbackIconProps } from '../FeedbackIconTypes';
import { ImageIcon } from './ImageIcon';

export const HateBuddyIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={HateBuddy} />;
};

export const HateAlternateBuddyIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={HateAlternateBuddy} />;
};

export const DislikeBuddyIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={DislikeBuddy} />;
};

export const DislikeAlternateBuddyIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={DislikeAlternateBuddy} />;
};

export const NeutralBuddyIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={NeutralBuddy} />;
};

export const NeutralAlternateBuddyIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={NeutralAlternateBuddy} />;
};

export const LikeBuddyIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={LikeBuddy} />;
};

export const LikeAlternateBuddyIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={LikeAlternateBuddy} />;
};

export const LoveBuddyIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={LoveBuddy} />;
};

export const LoveAlternateBuddyIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={LoveAlternateBuddy} />;
};

export const BuddyScoreMap: Record<EmotionScore, FeedbackIconComponent> = {
  0: HateBuddyIcon,
  1: DislikeBuddyIcon,
  2: NeutralBuddyIcon,
  3: LikeBuddyIcon,
  4: LoveBuddyIcon,
};

export const AlternateBuddyScoreMap: Record<EmotionScore, FeedbackIconComponent> = {
  0: HateAlternateBuddyIcon,
  1: DislikeAlternateBuddyIcon,
  2: NeutralAlternateBuddyIcon,
  3: LikeAlternateBuddyIcon,
  4: LoveAlternateBuddyIcon,
};
